import React from 'react';
import PropTypes from 'prop-types';

const EmailAddresses = ({ className, disabled = false, style }) => {
  return (
    <svg width="64px" height="64px" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" className={className} style={style}>
      <defs>
        <filter x="-1.0%" y="-4.8%" width="101.9%" height="109.7%" filterUnits="objectBoundingBox" id="filter-1">
          <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.68627451   0 0 0 0 0.756862745   0 0 0 0 0.882352941  0 0 0 1 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
      </defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="dashboard" transform="translate(-633.000000, -1032.000000)" fillRule="nonzero">
          <g id="Dashboard/Block/Stat/Single-Stat-Copy" filter="url(#filter-1)" transform="translate(96.000000, 957.000000)">
            <g id="Organism/Stats/Fancy+DataPoints" transform="translate(18.984751, 77.000000)">
              <g id="Molecule/Stats/Stats+Icons(footer)" transform="translate(521.000000, 0.000000)">
                <g id="Atom/Icon/emailAddresses/Active" transform="translate(1.015249, 0.000000)">
                  <circle id="Oval-2" fill={disabled ? '#F5F8FC' : '#E8F0FE'} cx="28" cy="28" r="28"></circle>
                  <g id="48px_email-83" transform="translate(11.000000, 16.000000)">
                    <path d="M32.2826087,24 L0.717391304,24 C0.321190435,24 0,23.6839624 0,23.2941176 L0,0.705882353 C0,0.316037647 0.321190435,0 0.717391304,0 L32.2826087,0 C32.6788096,0 33,0.316037647 33,0.705882353 L33,23.2941176 C33,23.6839624 32.6788096,24 32.2826087,24 Z" id="Shape" fill={disabled ? '#D1D5DB' : '#105EEB'}></path>
                    <path d="M16.5000023,8 C16.6730445,8 16.8457351,8.06320727 16.9826996,8.18892364 L32.7653279,22.7343782 C32.984606,22.9367927 33.0585189,23.2549745 32.9516849,23.5348073 C32.8448436,23.8153382 32.5789781,24 32.2826306,24 L0.717374009,24 C0.421026467,24 0.15516092,23.8153382 0.0483197007,23.5348 C-0.0585215188,23.2549673 0.015391399,22.9367855 0.234676671,22.7343709 L16.0173049,8.18891636 C16.1542695,8.06320727 16.3269601,8 16.5000023,8 Z" id="Shape" fill={disabled ? '#7D7F83' : '#0C49B3'}></path>
                    <path d="M16.4999984,16 C16.3269563,16 16.1542656,15.9367927 16.0173011,15.8110764 L0.234673491,1.26562182 C0.0153882281,1.06320727 -0.0585175126,0.745025455 0.0483165285,0.4652 C0.155157743,0.184661818 0.421023279,0 0.717370808,0 L32.282626,0 C32.5789736,0 32.8448391,0.184661818 32.9516803,0.4652 C33.0585215,0.745032727 32.9846086,1.06321455 32.7653233,1.26562909 L16.9826957,15.8110836 C16.8457312,15.9367927 16.6730406,16 16.4999984,16 Z" id="Shape" fill={disabled ? '#ECEFF6' : '#3077F1'}></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

EmailAddresses.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default EmailAddresses;
